import styled from 'styled-components';

export const StyledButton = styled.button`
  padding: 5px;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  transition: background-color 0.3s ease;
`;
